import React, { useContext, useState } from "react";
import { UserContext, setCurrentUser } from "../../contexts/user.context";
import { signInWithGooglePopup, createUserDocumentFromAuth, signUpWithEmail, signInWithEmail } from "../../utils/firebase/firebase.utils";
import { useNavigate } from "react-router-dom";
import "./signUpForm.style.scss";

const SignUpForm = ({ closeForm }) => {

    const navigate = useNavigate();
    const { currentUser } = useContext(UserContext);

    const [emailSignUp, setEmailSignUp] = useState("");
    const [emailSignIn, setEmailSignIn] = useState("");

    const [passwordSignUp, setPasswordSignUp] = useState("");
    const [passwordSignIn, setPasswordSignIn] = useState("");

    const [termsAccepted, setTermsAccepted] = useState(false);
    const [allowEmails, setAllowEmails] = useState(false);
    const [validationError, setValidationError] = useState(""); // New state for validation errors

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "emailSignUp") setEmailSignUp(value);
        if (name === "emailSignIn") setEmailSignIn(value);
        if (name === "passwordSignUp") setPasswordSignUp(value);
        if (name === "passwordSignIn") setPasswordSignIn(value);
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        if (name === "termsAccepted") setTermsAccepted(checked);
        if (name === "allowEmails") setAllowEmails(checked);
    };

    const logGoogleUser = async () => {
        try {
            const { user } = await signInWithGooglePopup();
            await createUserDocumentFromAuth(user);
            closeForm(); // Close the form on successful login
        } catch (error) {
            console.error("Error signing in with Google:", error);
        }
    };

    // Password validation function
    const validatePassword = (password) => {
        const minLength = /^(?=.{8,})/;
        const hasUpperCase = /^(?=.*[A-Z])/;
        const hasLowerCase = /^(?=.*[a-z])/;
        const hasNumber = /^(?=.*[0-9])/;
        const hasSpecialChar = /^(?=.*[!@#\$%\^&\*])/;

        if (!minLength.test(password)) {
            return "Password must be at least 8 characters long.";
        }
        if (!hasUpperCase.test(password)) {
            return "Password must contain at least one uppercase letter.";
        }
        if (!hasLowerCase.test(password)) {
            return "Password must contain at least one lowercase letter.";
        }
        if (!hasNumber.test(password)) {
            return "Password must contain at least one number.";
        }
        if (!hasSpecialChar.test(password)) {
            return "Password must contain at least one special character.";
        }
        return null; // Valid password
    };

    const handleEmailSignUp = async () => {
        if (!termsAccepted) {
            setValidationError("Please accept the terms and conditions.");
            return;
        }

        if (!emailSignUp || !passwordSignUp) {
            setValidationError("Please input email and password.");
            return;
        }

        const passwordError = validatePassword(passwordSignUp);

        if (passwordError) {
            setValidationError(passwordError); // Set validation error message
            return;
        }

        try {
            const user = await signUpWithEmail(emailSignUp, passwordSignUp);
            console.log('Signed up successfully:', user);
            closeForm(); // Close form on successful sign-up
        } catch (error) {
            console.error('Sign up failed:', error.message);
        }
    };

    const handleEmailSignIn = async () => {
        if (!emailSignIn || !passwordSignIn) {
            setValidationError("Please input email and password.");
            return;
        }

        try {
            const user = await signInWithEmail(emailSignIn, passwordSignIn);
            console.log('Signed in successfully:', user);
            closeForm(); // Close form on successful sign-in
        } catch (error) {
            console.error('Sign in failed:', error.message);
        }
    };

    const [showPasswordSignUp, setShowPasswordSignUp] = useState(false);
    const [showPasswordSignIn, setShowPasswordSignIn] = useState(false);

    const toggleShowPasswordSignUp = () => {
        setShowPasswordSignUp(!showPasswordSignUp);
    };
    const toggleShowPasswordSignIn = () => {
        setShowPasswordSignIn(!showPasswordSignIn);
    };

    return (
        <div className="signupform-pop-up-container">
            <div className="signupform-pop-up">
                <div className="signupform-pop-up-header">
                    <div className="title">
                        <div
                            className="close pointer"
                            style={{
                                backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat'
                            }}
                            onClick={() => closeForm()}
                        >
                        </div>
                    </div>
                </div>
                <div className="signupform-pop-up-scroll-view">
                    <div className="sign-up-form">
                        <div style={{ display: "flex", justifyContent: "space-evenly" }}>

                            {/* Sign Up= */}
                            <div style={{ display: "flex", flexDirection: 'column', width: '30%' }}>
                                <h3 style={{ margin: 0 }}>Sign Up</h3>
                                <p ><strong>Create an account</strong> and start today!</p>
                                <p style={{ fontSize: 'small', marginBottom: 0, marginTop: '12px', textAlign: 'left', color: 'darkgray', cursor: 'default', fontWeight: '500' }}>Email</p>
                                <input
                                    type="email"
                                    name="emailSignUp"
                                    placeholder="Email"
                                    value={emailSignUp}
                                    onChange={handleChange}
                                    style={{ boxSizing: 'border-box' }}
                                />
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <p style={{ fontSize: 'small', marginBottom: 0, marginTop: '12px', textAlign: 'left', color: 'darkgray', cursor: 'default', fontWeight: '500' }}>Password</p>
                                    {
                                        !showPasswordSignUp ? (
                                            <p
                                                onClick={toggleShowPasswordSignUp}
                                                style={{ fontSize: 'small', marginBottom: 0, marginTop: '12px', textAlign: 'right', color: 'darkgray', cursor: 'pointer', fontWeight: '500' }}
                                            >Show</p>
                                        ) : (
                                            <p
                                                onClick={toggleShowPasswordSignUp}
                                                style={{ fontSize: 'small', marginBottom: 0, marginTop: '12px', textAlign: 'right', color: 'darkgray', cursor: 'pointer', fontWeight: '500' }}
                                            >Hide</p>
                                        )
                                    }
                                </div>
                                <input
                                    type={showPasswordSignUp ? "text" : "password"}
                                    name="passwordSignUp"
                                    placeholder="Password"
                                    value={passwordSignUp}
                                    onChange={handleChange}
                                    style={{ boxSizing: 'border-box' }}
                                />

                                {/* Display validation error */}
                                {
                                    validationError &&
                                    <p style={{ color: 'red', fontSize: 'small', marginBottom: 0 }}>
                                        {validationError}
                                    </p>
                                }

                                <div style={{ display: 'flex', gap: '4px', marginTop: '20px' }}>
                                    <input
                                        type="checkbox"
                                        name="termsAccepted"
                                        checked={termsAccepted}
                                        onChange={handleCheckboxChange}
                                        style={{ width: '12px' }}
                                    />
                                    <p style={{ margin: 0 }}>I accept the <span onClick={() => window.open('./terms', '_blank')}>terms and conditions</span>.</p>
                                </div>
                                <div style={{ display: 'flex', gap: '4px', marginTop: '8px' }}>
                                    <input
                                        type="checkbox"
                                        name="allowEmails"
                                        checked={allowEmails}
                                        onChange={handleCheckboxChange}
                                        style={{ width: '12px' }}
                                    />
                                    <p style={{ margin: 0 }}>Allow emails about challenges.</p>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    {
                                        !emailSignUp || !passwordSignUp || !termsAccepted ? (
                                            <div className="google-sign-up-button-inactive">
                                                <p>Sign Up</p>
                                            </div>
                                        ) : (
                                            <div className="utility-button" onClick={handleEmailSignUp}>
                                                <p>Sign Up</p>
                                            </div>
                                        )
                                    }
                                </div>

                                <p style={{ marginTop: '28px' }}>Or sign up with <strong>your Google account</strong></p>
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <div
                                            className="google-sign-up-button"
                                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}
                                            onClick={logGoogleUser}
                                        >
                                            <div
                                                style={{
                                                    backgroundImage: `url(${'https://cdn-icons-png.flaticon.com/256/720/720255.png'})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat',
                                                    height: '24px',
                                                    width: '24px'
                                                }}
                                            ></div>
                                            <p>Continue with Google</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Sign In */}
                            <div style={{ display: "flex", flexDirection: 'column', width: '30%' }}>
                                <h3 style={{ margin: 0 }}>Sign In</h3>
                                <p>Already have an account?<strong> Sign in</strong> here!</p>
                                {/* Login form */}
                                <p style={{ fontSize: 'small', marginBottom: 0, marginTop: '12px', textAlign: 'left', color: 'darkgray', cursor: 'default', fontWeight: '500' }}>Email</p>
                                <input
                                    type="email"
                                    name="emailSignIn"
                                    placeholder="Email"
                                    value={emailSignIn}
                                    onChange={handleChange}
                                    style={{ boxSizing: 'border-box' }}
                                />
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <p style={{ fontSize: 'small', marginBottom: 0, marginTop: '12px', textAlign: 'left', color: 'darkgray', cursor: 'default', fontWeight: '500' }}>Password</p>
                                    {
                                        !showPasswordSignIn ? (
                                            <p
                                                onClick={toggleShowPasswordSignIn}
                                                style={{ fontSize: 'small', marginBottom: 0, marginTop: '12px', textAlign: 'right', color: 'darkgray', cursor: 'pointer', fontWeight: '500' }}
                                            >Show</p>
                                        ) : (
                                            <p
                                                onClick={toggleShowPasswordSignIn}
                                                style={{ fontSize: 'small', marginBottom: 0, marginTop: '12px', textAlign: 'right', color: 'darkgray', cursor: 'pointer', fontWeight: '500' }}
                                            >Hide</p>
                                        )
                                    }
                                </div>
                                <input
                                    type={showPasswordSignIn ? "text" : "password"}
                                    name="passwordSignIn"
                                    placeholder="Password"
                                    value={passwordSignIn}
                                    onChange={handleChange}
                                    style={{ boxSizing: 'border-box' }}
                                />
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    {
                                        !emailSignIn || !passwordSignIn ? (
                                            <div className="google-sign-up-button-inactive">
                                                <p>Sign In</p>
                                            </div>
                                        ) : (
                                            <div className="utility-button" onClick={handleEmailSignIn}>
                                                <p>Sign In</p>
                                            </div>
                                        )
                                    }
                                </div>
                                <p
                                    style={{ fontSize: 'small', cursor: 'pointer', marginBottom: 0, marginTop: '4px', color: 'grey' }}
                                    onClick={() => navigate('/forgotPassword')}
                                >Forgot Password
                                </p>
                                <p style={{ marginTop: '28px' }}>Or sign in with <strong>your Google account</strong></p>
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <div
                                            className="google-sign-up-button"
                                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}
                                            onClick={logGoogleUser}
                                        >
                                            <div
                                                style={{
                                                    backgroundImage: `url(${'https://cdn-icons-png.flaticon.com/256/720/720255.png'})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat',
                                                    height: '24px',
                                                    width: '24px'
                                                }}
                                            ></div>
                                            <p>Continue with Google</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default SignUpForm;